import axios from "axios";
import { getApiHost } from "../state/ducks/api";

export async function updateDocument(
  bearerToken,
  clientId,
  documentId,
  doc,
  versionId
) {
  const apiHost = await getApiHost();
  const response = await axios.put(
    `${apiHost}/api/clients/${clientId}/documents/${documentId}`,
    doc,
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
      params: {
        ...{ restoreVersion: versionId },
      },
    }
  );

  return response.data;
}

export async function getDocumentBytesNew(url) {
  const response = await axios.get(url, {
    responseType: "blob",
  });
  return response.data;
}
